import React, { useEffect, useReducer } from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import { PrinterFill as Printer} from 'react-bootstrap-icons';
import { Link, useParams } from 'react-router-dom';
import { Currency } from '../lib/components/Currency';
import { WithApiAccess } from "../lib/HigherOrderComponents/WithApiAccess";
import { LoadingSpinner } from '../lib/components/LoadingSpinner';
import { FormattedDate } from '../lib/components/FormattedDate';
import { Address } from '../lib/components/Address';
import { ContractLayout } from './ContractLayout';
import { withHeaderMessages } from '../higherOrderComponents/WithHeaderMessages';
import spinner from '../static/images/spinner.gif';

const ContractDetails = (props) => {

    const initialState = {
        contract: {
            provider: {
                address: {}
            },
            purchaser: {
                address: {}
            },
            recipients: [],
        },
        payoff: {
        },
        disbursementPayouts: [],
        disbursementPayoutsLoading: true,
        payoffLoading: true,
        isLoading: true
    }

    const reducer = (state, action) => {
        switch (action.type) {
            case 'contractDetails':
                return {
                    ...state,
                    contract: action.payload,
                    isLoading: false
                }
            case 'payoffDetails':
                return {
                    ...state,
                    payoff: action.payload,
                    payoffLoading: false
                }
            case 'payoutDetails':
                return {
                    ...state,
                    disbursementPayouts: action.payload,
                    disbursementPayoutsLoading: false
                }
            case 'hideLoader': 
                return {
                    ...state,
                    isLoading: false
                }
            default:
                throw new Error();
        }
    }
    
    const [contractDetails, dispatch] = useReducer(reducer, initialState);
    const { number } = useParams()

    useEffect(() => {
        async function getContractDetails() {
            props.header.setHeader("contractDetails");
            const res = await props.api.get(`/api/contract/${number}`);
            dispatch({ type: 'contractDetails', payload: res.data})
        }
        getContractDetails();
    }, [])

    useEffect(() => {
        async function getPayoutDetails() {
            const res = await props.api.get(`/api/contract/${number}/disbursement-payouts`)
            dispatch({ type: 'payoutDetails', payload: res.data})
            hideLoader();
        }
        getPayoutDetails();
    }, [])
    
    useEffect(() => {
        async function getPayoffDetails() {
            try {
                const res = await props.api.get(`/api/contract/${number}/payoff`);
                dispatch({ type: 'payoffDetails', payload: res.data})
                hideLoader();
            } catch (e){
                hideLoader();
            }
        }
        getPayoffDetails();
    }, [])


    const hideLoader = () => {
        dispatch({type: "hideLoader"});
    }

    const chunkArray = (array, chunkSize) => {
        return Array(Math.ceil(array.length / chunkSize))
                    .fill()
                    .map((_, index) => index * chunkSize)
                    .map(begin => array.slice(begin, begin + chunkSize));
    }

    const renderDisbursementsHeader = () => {
        return (
            <thead>
                <tr>
                    <th style={{fontWeight: "bold"}}>Who Was Paid</th>
                    <th style={{fontWeight: "bold"}}>Payout Date</th>
                    <th style={{fontWeight: "bold"}}>Pmt Method</th>
                    <th style={{fontWeight: "bold"}}>Principal</th>
                    <th style={{fontWeight: "bold"}}>Income</th>
                    <th style={{fontWeight: "bold"}}>Total</th>
                </tr>
            </thead>
        )
    }

    const renderDisbursementsDetails = (p) => {
        return (
            <tr>
                <td>{p.paidTo !== 'Unknown' ? p.paidTo : ''} {p.paidTo !== 'Provider' ? p.paidToName : ''}</td>
                <td><a><FormattedDate date={p.posted} /></a></td>
                <td><a>{p.payoutMethod}</a></td>
                <td><a><Currency amount={p.principal} /></a></td>
                <td><a><Currency amount={p.income} /></a></td>
                <td><a><Currency amount={p.income + p.principal} /></a></td>
            </tr>
        )
    }

    const renderDisbursementsHeaderWithGuaranteed = () => {
        return (
            <thead>
                <tr>
                    <th style={{fontWeight: "bold"}}></th>
                    <th style={{fontWeight: "bold"}}></th>
                    <th style={{fontWeight: "bold"}}></th>
                    <th style={{fontWeight: "bold"}}></th>
                    <th style={{fontWeight: "bold"}}></th>
                    <th style={{fontWeight: "bold"}}></th>
                    <th style={{fontWeight: "bold"}} colSpan='2'>Guaranteed</th>
                    <th style={{fontWeight: "bold"}} colSpan='2'>Non-Guaranteed</th>
                    <th style={{fontWeight: "bold"}}></th>
                </tr>
                <tr>
                    <th style={{fontWeight: "bold"}}>Who Was Paid</th>
                    <th style={{fontWeight: "bold"}}>Payout Date</th>
                    <th style={{fontWeight: "bold"}}>Pmt Method</th>
                    <th style={{fontWeight: "bold"}}>Principal</th>
                    <th style={{fontWeight: "bold"}}>Income</th>
                    <th style={{fontWeight: "bold"}}>Total</th>
                    <th style={{fontWeight: "bold"}}>Principal</th>
                    <th style={{fontWeight: "bold"}}>Income</th>
                    <th style={{fontWeight: "bold"}}>Principal</th>
                    <th style={{fontWeight: "bold"}}>Income</th>
                    <th style={{fontWeight: "bold"}}>Total</th>
                </tr>
            </thead>
        )
    }

    const renderDisbursementsDetailsWithGuaranteed = (p) => {
        return (
            <tr>
                <td>{p.paidTo !== 'Unknown' ? p.paidTo : ''} {p.paidTo !== 'Provider' ? p.paidToName : ''}</td>
                <td><a><FormattedDate date={p.posted} /></a></td>
                <td><a>{p.payoutMethod}</a></td>
                <td><a><Currency amount={p.principal} /></a></td>
                <td><a><Currency amount={p.income} /></a></td>
                <td><a><Currency amount={p.income + p.principal} /></a></td>
                <td><a><Currency amount={p.disbursedGuaranteedPrincipal} /></a></td>
                <td><a><Currency amount={p.disbursedGuaranteedIncome} /></a></td>
                <td><a><Currency amount={p.disbursedNonGuaranteedPrincipal} /></a></td>
                <td><a><Currency amount={p.disbursedNonGuaranteedIncome} /></a></td>
                <td><a><Currency amount={p.disbursedGuaranteedPrincipal +
                    p.disbursedGuaranteedIncome +
                    p.disbursedNonGuaranteedPrincipal +
                    p.disbursedNonGuaranteedIncome} /></a></td>
            </tr>
        )
    }

    const renderPurchases = (contract) => {
        const purchases = contract.purchases;
        if (!purchases) {
            return <LoadingSpinner />;
        }
        const { payoff, payoffLoading } = contractDetails;

        const planTotalTotal = purchases.map(p => p.netPrice).reduce((a, b) => a + b, 0);
        const amountPaidTotal = purchases.map(p => p.totalTrusted + p.totalRetained + p.disbursedGuaranteedPrincipal + p.disbursedNonGuaranteedPrincipal).reduce((a, b) => a + b, 0);
        const balanceDueTotal = purchases.map(p => (p.totalToRetain - p.totalRetained) + (p.totalToTrust - p.totalTrusted)).reduce((a, b) => a + b, 0);
        const totalTrustedTotal = purchases.map(p => p.totalTrusted).reduce((a, b) => a + b, 0);
        const totalRetainedTotal = purchases.map(p => p.totalRetained).reduce((a, b) => a + b, 0);
        const totalIncomeTotal = purchases.map(p => p.income).reduce((a, b) => a + b, 0);
        const currentValueTotal = purchases.map(p => p.totalTrusted + p.income).reduce((a, b) => a + b, 0);
    
        return (
            (purchases && purchases.length > 0) &&
                <div>
                    <Row>
                        <Col sm={6}>
                            <h4>Itemization</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Table className="dq2-table container table-borderless">
                                <thead>
                                    <tr>
                                        <th style={{fontWeight: "bold"}}>Item Number &amp; Description</th>
                                        {contract.provider.providerType === 2 && 
                                            <th style={{fontWeight: "bold"}}>Plot Locations</th>
                                        }
                                        <th style={{fontWeight: "bold"}}>Status</th>
                                        <th style={{fontWeight: "bold", textAlign: "right"}}>Plan Total</th>
                                        <th style={{fontWeight: "bold", textAlign: "right"}}>Amount Paid</th>
                                        <th style={{fontWeight: "bold", textAlign: "right"}}>Balance Due</th>
                                        <th style={{fontWeight: "bold", textAlign: "right"}}>Total Trusted</th>
                                        <th style={{fontWeight: "bold", textAlign: "right"}}>Total Retained</th>
                                        <th style={{fontWeight: "bold", textAlign: "right"}}>Total Income</th>
                                        <th style={{fontWeight: "bold", textAlign: "right"}}>Current Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {purchases.map(p => {
                                        return (
                                        <tr>
                                            <td>{p.itemNumber} {p.description}</td>
                                            {contract.provider.providerType === 2 &&
                                                <td>{p.plotLocation}</td>
                                            }
                                            <td>{p.currentStatus}</td>
                                            <td style={{textAlign: "right"}}><Currency amount={p.netPrice} /></td>
                                            <td style={{textAlign: "right"}}><Currency amount={p.totalTrusted + p.totalRetained + p.disbursedGuaranteedPrincipal + p.disbursedNonGuaranteedPrincipal} /></td>
                                            <td style={{textAlign: "right"}}><Currency amount={(p.totalToRetain - p.totalRetained) + (p.totalToTrust - p.totalTrusted)} /></td>
                                            <td style={{textAlign: "right"}}><Currency amount={p.totalTrusted} /></td>
                                            <td style={{textAlign: "right"}}><Currency amount={p.totalRetained} /></td>
                                            <td style={{textAlign: "right"}}><Currency amount={p.income} /></td>
                                            <td style={{textAlign: "right"}}><Currency amount={p.totalTrusted + p.income} /></td>
                                        </tr>)
                                    })}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        {contract.provider.providerType === 2 &&
                                            <td></td>
                                        }
                                        <td></td>
                                        <td style={{fontWeight: "bold", textAlign: "right"}}>Total</td>
                                        <td style={{fontWeight: "bold", textAlign: "right"}}><Currency amount={planTotalTotal} /></td>
                                        <td style={{fontWeight: "bold", textAlign: "right"}}>
                                            <Currency amount={amountPaidTotal} />
                                            { (contract.nonWaivedNonKeptProviderFees && contract.nonWaivedNonKeptProviderFees !== 0) &&
                                                <span>~</span>
                                            }
                                        </td>
                                        <td style={{fontWeight: "bold", textAlign: "right"}}><Currency amount={balanceDueTotal} /></td>
                                        <td style={{fontWeight: "bold", textAlign: "right"}}><Currency amount={totalTrustedTotal} /></td>
                                        <td style={{fontWeight: "bold", textAlign: "right"}}><Currency amount={totalRetainedTotal} /></td>
                                        <td style={{fontWeight: "bold", textAlign: "right"}}><Currency amount={totalIncomeTotal} /></td>
                                        <td style={{fontWeight: "bold", textAlign: "right"}}><Currency amount={currentValueTotal} /></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td colSpan="2" style={{fontWeight: "bold", textAlign: "right"}}>Payoff Finance Amount</td>
                                        <td style={{fontWeight: "bold", textAlign: "right"}}>
                                            { payoffLoading &&
                                                <div>
                                                    <span>Loading...<img src={spinner} alt="Loading ..." /></span>
                                                </div>
                                            }
                                            { !payoffLoading &&
                                                <Currency amount={payoff.payoffFinanceChargeAmount} />
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td colSpan="2" style={{fontWeight: "bold", textAlign: "right"}}>Payoff Amount</td>
                                        <td style={{fontWeight: "bold", textAlign: "right"}}>
                                            { payoffLoading &&
                                                <span>Loading...<img src={spinner} alt="Loading ..." /></span>
                                            }
                                            { !payoffLoading &&
                                                <Currency amount={payoff.payoffAmount} />
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="9" style={{textAlign: "center"}}>
                                            { (contract.nonWaivedNonKeptProviderFees && contract.nonWaivedNonKeptProviderFees !== 0) &&
                                                <div>~ Excludes Finance Charges and/or other Provider Fees of <Currency amount={contract.nonWaivedNonKeptProviderFees} /> as they are not item specific</div>
                                            }
                                        </td>
                                    </tr>
                                </tfoot>
                            </Table>
                        </Col>
                    </Row>
                </div>
        )
    }

    if (contractDetails.isLoading) {
        return <LoadingSpinner />;
    }

    const { contract, payoff, payoffLoading, disbursementPayouts, disbursementPayoutsLoading } = contractDetails;
    const agents = [...new Set([contract.agent]
                    .concat(contract.purchaseAgents)
                    .filter(a => a && (a.firstName || a.lastName))
                    .map(a => a.firstName + " " + a.lastName))];
    const agentLabel = agents.length === 0 ? "" : (agents.length === 1 ? "Agent:" : "Agents:");

    return (
        <ContractLayout contractNumber={number} contractStatus={contract.status} className="border-top border-4">
            <Row style={{marginBottom: "20px", paddingLeft: "30px"}}>
                <Col className="me-auto" >
                <Link
                    className='printer-friendly'
                    target="_blank"
                    to={{
                        pathname:`/contracts/${number}/for-print`,
                        state: { contractNumber: number }
                    }}
                    >{<Printer />}Printer friendly</Link>
                </Col>
            </Row>
            {(contract.notations && contract.notations.length > 0) &&
                <Row>
                    <Col>
                        <div className='color-red'>
                            {contract.status === "Pending" 
                                ? "Contract is in Pended status due to the following reason(s):" 
                                : "Contract is pending distribution due to the following reason(s):"}
                        </div>
                        <ul className='color-red'>
                            {contract.notations.map((note) =>(
                                <li>
                                    {note.text}
                                </li>
                            ))}
                        </ul>
                    </Col>
                </Row>
            }
            <span className='border-top border-3'></span>
            { contract.hasEarlyPayoffOption && !contract.earlyPayoffExpired &&
                <Row className="section mt-5" style={{marginBottom: "30px"}}>
                    <Col>
                        <div className="alert alert-info" role="alert">
                            <h4 className="alert-heading">Early Payoff</h4>
                            <div><p>Contract has Early Payoff option and is within Grace Period and can be paid off with <Currency amount={contract.earlyPayoffAmount} /></p></div>
                            <div><label>Grace Period ends:</label> <FormattedDate date={contract.earlyPayoffExpiresOn} /></div> 
                        </div>
                    </Col>
                </Row>
            }

            <Row className="section mt-4" style={{marginBottom: "30px"}}>
                <Col>
                    <label>Provider Contract #</label>
                    <br />
                    {contract.providerNumber}
                    <br />
                    <br />
                    <br />
                    <label>Guaranteed?</label>
                    <br />
                    {contract.guaranteed ? "Yes" : "No"}
                    <br />
                    <br />
                    <br />
                    <label>Accepted Date</label>
                    <br />
                    <FormattedDate date={contract.accepted} />
                    <br />
                    <br />
                    <br />
                    <label>At Need / Property Only?</label>
                    <br />
                    {contract.atNeed ? "Yes" : "No"}
                    <br />
                    <br />
                    <br />
                </Col>
                <Col>

                    <label>Status</label>
                    <br />
                    {contract.status}
                    <br />
                    <br />
                    <br />
                    <label>Irrevocable?</label>
                    <br />
                    {contract.irrevocable ? "Yes" : "No"}
                    <br />
                    <br />
                    <br />
                    <label>Signed Date</label>
                    <br />
                    <FormattedDate date={contract.signed} />
                    <br />
                    <br />
                    <br />
                </Col>
                <Col>

                    <div className="label-group"><label>Plan Total:</label> <Currency amount={contract.netPrice} /></div> 
                    <div className="label-group">
                        <label>Amount Paid:</label> 
                        <Currency amount={contract.paid} />{ (contract.nonWaivedNonKeptProviderFees && contract.nonWaivedNonKeptProviderFees !== 0) ? "**" : ""}
                    </div> 
                    <div className="label-group"><label>Balance Due:</label> <Currency amount={contract.balance} /></div> 
                    <div className="label-group">
                        <label>Payoff Finance Amount:</label> 
                        { payoffLoading &&
                            <span>Loading...<img src={spinner} alt="Loading ..." /></span>
                        }
                        { !payoffLoading &&
                            <Currency amount={payoff.payoffFinanceChargeAmount} />
                        }
                    </div> 

                    <div className="label-group">
                        <label>Payoff Amount:</label> 
                        { payoffLoading &&
                            <span>Loading...<img src={spinner} alt="Loading ..." /></span>
                        }
                        { !payoffLoading &&
                            <Currency amount={payoff.payoffAmount} />
                        }
                    </div> 
                    <div className="label-group"><label>Total Retained:</label> <Currency amount={contract.retained} /></div> 
                    <div className="label-group"><label>Total Income:</label> <Currency amount={contract.income} /></div> 
                    <div className="label-group"><label>Current Value:</label> <Currency amount={contract.value} /></div> 
                    { (contract.nonWaivedNonKeptProviderFees && contract.nonWaivedNonKeptProviderFees !== 0) &&
                        <div>** Includes Finance Charges and/or other Provider Fees of <Currency amount={contract.nonWaivedNonKeptProviderFees} /></div>
                    }
                </Col>
                <Col sm={5} style={{paddingLeft: "30px"}}>
                    <Row>
                        <Col sm={6} className="border-start border-3">
                                <strong>Provider:</strong>
                                <br />
                                <br />
                                {contract.provider.name} ({contract.provider.code})<br/>
                                <Address address={contract.provider.address} /><br />
                                <strong>{agentLabel}</strong>
                                <br />
                                <br />
                                {agents.map((a,ai) =>(
                                    <div key={ai}>
                                        {a}<br/>
                                    </div>
                                ))}
                        </Col>
                        <Col sm={6}>
                                <strong>Recipients:</strong>
                                <br />
                                <br />
                                {contract.recipients.map((r,ri) =>(
                                    <div key={ri}>
                                        {r.firstName} {r.lastName}<br/>
                                        <Address address={r.address} /><br />
                                    </div>
                                ))}
                                <strong>Purchaser:</strong>
                                <br />
                                <br />
                                {contract.purchaser.firstName} {contract.purchaser.lastName}<br/>
                                <Address address={contract.purchaser.address} /><br />
                        </Col>
                    </Row>
                </Col>
            </Row>
            {renderPurchases(contract)}
            { disbursementPayoutsLoading &&
                <span>loading...<img src={spinner} alt="loading ..." /></span>
            }
            {!disbursementPayoutsLoading && disbursementPayouts.length > 0 &&
                <div>
                    <Row>
                        <Col sm={6}>
                            <h4>Distributions</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <table className="table table-sm dq2-table">
                                {(!contract.provider.disbursementsBreakout) &&
                                    renderDisbursementsHeader()
                                }
                                {(contract.provider.disbursementsBreakout) &&
                                    renderDisbursementsHeaderWithGuaranteed()
                                }
                                <tbody>
                                    {disbursementPayouts.map(p => {
                                        return !contract.provider.disbursementsBreakout
                                        ? renderDisbursementsDetails(p)
                                        : renderDisbursementsDetailsWithGuaranteed(p)
                                    })}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </div>
            }
        </ContractLayout>
    );
}

export default withHeaderMessages(WithApiAccess(ContractDetails));